import { generateLocalizationConfig, Namespaces } from 'swo-ciam-common-react';
import i18n from 'i18next';
import { loadMessages } from '@progress/kendo-react-intl';
import { i18nMenuCommon } from '@swo/menu-common';
import { LocaleTranslationKeysEnum } from './locale-translation-keys.enum';

generateLocalizationConfig({
  backend: {
    loadPath: `/locales/{{lng}}/{{ns}}.json?v=${import.meta.env.VITE_LOCALE_HASH}`,
  },
}).then(() => {
  loadMessages(i18n.getResourceBundle(i18n.language, 'kendo'), i18n.language);
  i18nMenuCommon.changeLanguage(i18n.language);
  i18nMenuCommon.addResourceBundle(
    i18n.language,
    LocaleTranslationKeysEnum.SwoUserInfoMenuCommon,
    i18n.t(LocaleTranslationKeysEnum.SwoUserInfoMenuCommon, { returnObjects: true }),
    true,
    true
  );

  i18n.on('languageChanged', (language: string) => {
    if (language === i18nMenuCommon.language) {
      return;
    }

    loadMessages(i18n.getResourceBundle(language, Namespaces.KENDO), language);

    // Override internal '@swo/menu-common' package translations with our own.
    i18nMenuCommon.changeLanguage(language);
    i18nMenuCommon.addResourceBundle(
      language,
      LocaleTranslationKeysEnum.SwoUserInfoMenuCommon,
      i18n.t(LocaleTranslationKeysEnum.SwoUserInfoMenuCommon, { returnObjects: true }),
      true,
      true
    );
  });
});

export default i18n;
